import type { CATEGORIES_LIST_DATA, CATEGORIES_LIST_PARAMS } from './types'

import { DEFAULT_PADDING, DEFAULT_WIDTH, generateForAllDevice } from '../const'

export const DEFAULT_CATEGORIES_LIST_DATA = (): CATEGORIES_LIST_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'categories-list',
  categories: [],
  categoriesType: null,
})

export const DEFAULT_CATEGORIES_LIST_PARAMS = (): CATEGORIES_LIST_PARAMS =>
  generateForAllDevice({
    hidden: false,
    width: DEFAULT_WIDTH(),
    padding: DEFAULT_PADDING(),
  })